export const shortenName = (username: string) => {
    if (username.length > 10) {
        return `${username.slice(0, 10).concat('...')}`;
      }
      return username;
}